import React, { useState, useEffect, useRef } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { useJob } from "../../context/JobContext";
import { useOutletContext } from "react-router-dom";
import SessionStartCard from "../../components/ps-account/agreements/SessionStartCard";
import config from "../../config/config";
import { timeAgo } from "../../util_functions/helpers";
import { FaMapMarkerAlt, FaFire } from "react-icons/fa";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { FaCirclePlus, FaChevronUp } from "react-icons/fa6";
import { AiOutlineSchedule } from "react-icons/ai";
import { RotatingLines } from "react-loader-spinner";

const DashboardComponent = () => {
  const { workerUser } = useUser();
  const today = new Date();
  const [selectedDate, setSelectedDate] = useState(today.getDate());
  const { jobs, fetchAllJobs } = useJob();
  const [loading, setLoading] = useState(false);
  const [hoveredJobId, setHoveredJobId] = useState(null);
  const [openSection, setOpenSection] = useState("jobs");
  const sectionOrder = ["jobs", "announcements", "notifications"];
  const hasGroupOpen = !!openSection;

  const isMobile = useMediaQuery({ minWidth: 320, maxWidth: 1200 });

  const navigate = useNavigate();

  const announcementsRef = useRef(null);
  const notificationsRef = useRef(null);
  const jobsRef = useRef(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        await fetchAllJobs();
      } catch (err) {
        console.error("Error fetching jobs:", err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [fetchAllJobs]);

  useEffect(() => {
    if (openSection === "announcements") {
      announcementsRef.current?.focus();
    } else if (openSection === "notifications") {
      notificationsRef.current?.focus();
    } else if (openSection === "jobs") {
      jobsRef.current?.focus();
    }
  }, [openSection]);

  // const toggleSection = (section) => {
  //   setOpenSection((prev) => {
  //     if (prev === section) {
  //       const idx = sectionOrder.indexOf(section);
  //       const next = sectionOrder[(idx + 1) % sectionOrder.length];
  //       return next;
  //     }
  //     return section;
  //   });
  // };

  const toggleSection = (section) => {
  setOpenSection((prev) => {
    if (prev === section) {
      const idx = sectionOrder.indexOf(section);
      const next = sectionOrder[(idx + 1) % sectionOrder.length];
      return next;
    }
    return section;
  });
};

  const handleDateClick = (day) => {
    setSelectedDate(day);
    console.log("Selected day is :", day);
  };

  const viewJobDetails = (jobId) => {
    console.log(`Viewing details for job ID: ${jobId}`);
    navigate(`/account/ps-dashboard/job-listings/open/${jobId}`);
  };

  const daysInMonth = new Date(
    today.getFullYear(),
    today.getMonth() + 1,
    0
  ).getDate();
  const firstDayIndex = new Date(
    today.getFullYear(),
    today.getMonth(),
    1
  ).getDay();

  const handleMouseEnter = (jobId) => {
    setHoveredJobId(jobId);
  };

  const handleMouseLeave = () => {
    setHoveredJobId(null);
  };

  const truncateTitle = (title, wordLimit) => {
    const words = title.split(" ");
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(" ") + "...";
    }
    return title;
  };

  const recommendedJobsContent =
    jobs.length > 0 ? (
      <div className="recommended-jobs-container">
        {jobs.slice(0, 5).map((job) => (
          <div
            key={job.id}
            className="job-item-dashboard"
            onMouseEnter={() => handleMouseEnter(job.id)}
            onMouseLeave={handleMouseLeave}
            onClick={() => viewJobDetails(job.id)}
          >
            <h3>
              {hoveredJobId === job.id
                ? job.jobCraftDetails.jobTitle
                : truncateTitle(job.jobCraftDetails.jobTitle, 8)}
            </h3>
            <p className="job-detail-dashboard">
              <span className="job-detail-label">
                <FaMapMarkerAlt className="job-detail-icon fa-map-marker-alt" />
                <strong>Location</strong>
                <span className="user-dashboard-arrow">➤</span>
              </span>
              <span className="job-detail-value">{job.suburbValue}</span>
            </p>
            <p className="job-detail-dashboard">
              <span className="job-detail-label">
                <IoIosCheckmarkCircleOutline className="job-detail-icon chckmrk-outline" />
                <strong>Support Frequency</strong>
                <span className="user-dashboard-arrow">➤</span>
              </span>
              <span className="job-detail-value">{job.frequencyDetails.supportType}</span>
            </p>
            <p className="job-detail-dashboard">
              <span className="job-detail-label">
                <AiOutlineSchedule className="job-detail-icon fa-clock" />
                <strong>Date Posted</strong>
                <span className="user-dashboard-arrow">➤</span>
                <strong>{timeAgo(job.postedTime)}</strong> </span><span className="job-detail-value">ago</span>
            </p>
            <p className="job-detail-dashboard">
              <FaFire className="job-detail-icon fa-applications" />
              <span className="application-count">
                <strong>
                  {job.applicationCount}
                  {job.applicationCount > 15 ? "+" : ""}
                </strong>{" "}
                application{job.applicationCount !== 1 ? "s" : ""}
              </span>
            </p>
          </div>
        ))}
        {jobs.length > 5 && (
          <div className="see-all-recommended">
            <button
              onClick={() => navigate("/account/ps-dashboard/job-listings")}
              className="see-all-link"
            >
              See all recommended jobs →
            </button>
          </div>
        )}
      </div>
    ) : (
      <div className="no-jobs-placeholder">
        <img
          src="/images/no_results_found.png"
          alt="No results found"
          className="no-jobs-image"
        />
        <p>No jobs posted yet.</p>
      </div>
    );

  const announcementsContent = (
    <div className="announcement-update-container">
      <div className="news-grid">
        <div className="news-card">
          <div className="news-content">
            <p className="news-date">4/22/2025</p>
            <h3 className="news-title">Tax and super calculators</h3>
            <p className="news-description">Specify a date range and the percentage of your Will Care payments
              that you want to set aside for income tax or superannuation, and we
              will calculate the amount.</p>
          </div>
        </div>
      </div>
      <div className="news-grid">
        <div className="news-card">
          <div className="news-content">
            <p className="news-date">4/21/2025</p>
            <h3 className="news-title">OSH Tax Benefits Program</h3>
            <p className="news-description">We’ve partnered with YOUtax to give you exclusive discounts of 20% off
              tax returns and 40% off quarterly BAS filing.</p>
          </div>
        </div>
      </div>
      <div className="news-grid">
        <div className="news-card">
          <div className="news-content">
            <p className="news-date">4/20/2025</p>
            <h3 className="news-title">Tax and super calculators</h3>
            <p className="news-description">Specify a date range and the percentage of your Will Care payments
              that you want to set aside for income tax or superannuation, and we
              will calculate the amount.</p>
          </div>
        </div>
      </div>
      <div className="news-grid">
        <div className="news-card">
          <div className="news-content">
            <p className="news-date">4/19/2025</p>
            <h3 className="news-title">OSH Tax Benefits Program</h3>
            <p className="news-description">We’ve partnered with YOUtax to give you exclusive discounts of 20% off
              tax returns and 40% off quarterly BAS filing.</p>
          </div>
        </div>
      </div>
      <div className="news-grid">
        <div className="news-card">
          <div className="news-content">
            <p className="news-date">4/18/2025</p>
            <h3 className="news-title">Tax and super calculators</h3>
            <p className="news-description">Specify a date range and the percentage of your Will Care payments
              that you want to set aside for income tax or superannuation, and we
              will calculate the amount.</p>
          </div>
        </div>
      </div>
      <div className="news-grid">
        <div className="news-card">
          <div className="news-content">
            <p className="news-date">4/17/2025</p>
            <h3 className="news-title">OSH Tax Benefits Program</h3>
            <p className="news-description">We’ve partnered with YOUtax to give you exclusive discounts of 20% off
              tax returns and 40% off quarterly BAS filing.</p>
          </div>
        </div>
      </div>
    </div>
  );

  const notificationsContent = (
    <div className="dashboard-notification-section">
      <SessionStartCard />
      <div className="dashboard-alerts-container">
        {!workerUser?.isEmailVerified && (
          <div className="notification-item">
            <div className="icon-container alert" />
            <p>
              <strong>Email</strong> verification pending.
            </p>
          </div>
        )}
        {!workerUser?.phoneNumberVerified && (
          <div className="notification-item">
            <div className="icon-container alert" />
            <p>
              <strong>Phone number</strong> verification pending.
            </p>
          </div>
        )}
        {workerUser?.profilePhotoUpdated && (
          <div className="notification-item">
            <div className="icon-container warning" />
            <p>
              <strong>Profile photo</strong> awaiting approval.
            </p>
          </div>
        )}
        {workerUser?.bioUpdated && (
          <div className="notification-item">
            <div className="icon-container warning" />
            <p>
              <strong>Bio</strong> updated and awaiting approval.
            </p>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <>
      {isMobile ? (

        // <div className={`dwc-accordion ${openSection ? "has-open" : ""}`}>
        //   <div className="dwc-accordion-item">
        //     <button
        //       ref={notificationsRef}
        //       className={`dwc-accordion-header ${openSection === "notifications" ? "open" : ""
        //         }`}
        //       onClick={() => toggleSection("notifications")}
        //     >
        //       <span>Alerts / Notifications</span>
        //       {openSection === "notifications" ? (
        //         <FaChevronUp className="dwc-accordion-icon" />
        //       ) : (
        //         <FaCirclePlus className="dwc-accordion-icon" />
        //       )}
        //     </button>

        //     {openSection === "notifications" && (
        //       <div className="dwc-accordion-content">
        //         {notificationsContent}
        //       </div>
        //     )}
        //   </div>

        //   <div className="dwc-accordion-item">
        //     <button
        //       ref={announcementsRef}
        //       className={`dwc-accordion-header ${openSection === "announcements" ? "open" : ""
        //         }`}
        //       onClick={() => toggleSection("announcements")}
        //     >
        //       <span>Announcements & Updates</span>
        //       {openSection === "announcements" ? (
        //         <FaChevronUp className="dwc-accordion-icon" />
        //       ) : (
        //         <FaCirclePlus className="dwc-accordion-icon" />
        //       )}
        //     </button>

        //     {openSection === "announcements" && (
        //       <div className="dwc-accordion-content">
        //         {announcementsContent}
        //       </div>
        //     )}
        //   </div>

        //   <div className="dwc-accordion-item">
        //     <button
        //       ref={jobsRef}
        //       className={`dwc-accordion-header ${openSection === "jobs" ? "open" : ""
        //         }`}
        //       onClick={() => toggleSection("jobs")}
        //     >
        //       <span>Recommended Jobs for You</span>
        //       {openSection === "jobs" ? (
        //         <FaChevronUp className="dwc-accordion-icon" />
        //       ) : (
        //         <FaCirclePlus className="dwc-accordion-icon" />
        //       )}
        //     </button>

        //     {openSection === "jobs" && (
        //       <div className="dwc-accordion-content">
        //         {loading ? (
        //           <div className="jobs-loading-spinner-container">
        //             <RotatingLines
        //               visible={true}
        //               height="56"
        //               width="56"
        //               strokeWidth="1"
        //               animationDuration="0.75"
        //               ariaLabel="loading-jobs"
        //             />
        //           </div>
        //         ) : (
        //           recommendedJobsContent
        //         )}
        //       </div>
        //     )}
        //   </div>
        // </div>

        <div
  className="dwc-accordion"
  // style={{
  //   paddingBottom: openSection ? "80px" : "0px",
  // }}
>
  <div className="dwc-accordion-item">
    <button
      ref={notificationsRef}
      className={`dwc-accordion-header ${openSection === "notifications" ? "open" : ""}`}
      onClick={() => toggleSection("notifications")}
    >
      <span>Alerts / Notifications</span>
      {openSection === "notifications" ? (
        <FaChevronUp className="dwc-accordion-icon" />
      ) : (
        <FaCirclePlus className="dwc-accordion-icon" />
      )}
    </button>
    {openSection === "notifications" && (
      <div className="dwc-accordion-content">{notificationsContent}</div>
    )}
  </div>

  <div className="dwc-accordion-item">
    <button
      ref={announcementsRef}
      className={`dwc-accordion-header ${openSection === "announcements" ? "open" : ""}`}
      onClick={() => toggleSection("announcements")}
    >
      <span>Announcements & Updates</span>
      {openSection === "announcements" ? (
        <FaChevronUp className="dwc-accordion-icon" />
      ) : (
        <FaCirclePlus className="dwc-accordion-icon" />
      )}
    </button>
    {openSection === "announcements" && (
      <div className="dwc-accordion-content">{announcementsContent}</div>
    )}
  </div>

  <div className="dwc-accordion-item">
    <button
      ref={jobsRef}
      className={`dwc-accordion-header ${openSection === "jobs" ? "open" : ""}`}
      onClick={() => toggleSection("jobs")}
    >
      <span>Recommended Jobs for You</span>
      {openSection === "jobs" ? (
        <FaChevronUp className="dwc-accordion-icon" />
      ) : (
        <FaCirclePlus className="dwc-accordion-icon" />
      )}
    </button>
    {openSection === "jobs" && (
      <div className="dwc-accordion-content">
        {loading ? (
          <div className="jobs-loading-spinner-container">
            <RotatingLines
              visible={true}
              height="56"
              width="56"
              strokeWidth="1"
              animationDuration="0.75"
              ariaLabel="loading-jobs"
            />
          </div>
        ) : (
          recommendedJobsContent
        )}
      </div>
    )}
  </div>
</div>

      ) : (
        <div className="dashboard-welcome-container">
          <div className="dashboard-right-column">
            <h1 className="recommended-jobs-header">
              Recommended Jobs for You
              <span className="circle-badge-indicator" />
            </h1>
            {loading ? (
              <div className="jobs-loading-spinner-container">
                <RotatingLines
                  visible={true}
                  height="56"
                  width="56"
                  strokeWidth="1"
                  animationDuration="0.75"
                  ariaLabel="loading-jobs"
                />
              </div>
            ) : (
              recommendedJobsContent
            )}
          </div>
          <div className="dashboard-right-column">
            <h1 className="dashboard-updates-header">
              Announcements & Updates
              <span className="circle-badge-indicator" />
            </h1>
            {announcementsContent}
          </div>
          <div className="dashboard-right-column">
            <h1 className="dashboard-notifications-header">
              Alerts / Notifications
              <span className="circle-badge-indicator" />
            </h1>
            {notificationsContent}
          </div>
        </div>
      )}
    </>
  );
};

export default DashboardComponent;
